// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const chatot: PokeData = {
  "id": 441,
  "name": "chatot",
  "height": 5,
  "weight": 19,
  "base_experience": 144,
  "types": [
    PokeType.NORMAL,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "fury-attack",
    "growl",
    "sing",
    "peck",
    "mimic",
    "mirror-move",
    "swift",
    "uproar",
    "taunt",
    "feather-dance",
    "hyper-voice",
    "air-cutter",
    "roost",
    "air-slash",
    "nasty-plot",
    "chatter",
    "synchronoise",
    "round",
    "echoed-voice",
    "hurricane",
    "parting-shot",
    "play-rough",
    "confide"
  ],
  "moves": [
    "gust",
    "growl",
    "peck",
    "hyper-voice",
    "roost",
    "air-slash",
    "chatter",
    "hurricane",
    "play-rough",
    "sky-attack",
    "tackle",
    "tri-attack",
    "tailwind"
  ],
  "evolution_chain": {
    "id": 228,
    "item": null,
    "species": [
      {
        "name": "chatot",
        "order": 462,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 98,
    "speed": 150,
    "ability_power": 152
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
